// A provider always stamps a zone on an event, so the raw value says nothing about intent.
// Only a zone that differs from the calendar's own is a choice the user made; an unknown
// calendar zone (older backend) leaves the event's zone standing rather than guessing.
export const getCalendarEventTimeZoneOverride = (
  eventTimeZone: string | null | undefined,
  calendarTimeZone: string | null | undefined,
): string | null => {
  if (!eventTimeZone || eventTimeZone === calendarTimeZone) {
    return null;
  }
  return eventTimeZone;
};
